import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ProjectById, SearchResults } from './interfaces/components';

export interface AppStoreState {
  renderSearchResults: boolean;
  showProjectDetails: boolean;
  showSavedInvestorPage: boolean;
  searchQuery: string;
  searchResults: SearchResults | null;
  projectById: ProjectById | null;
  loading: boolean;
  projectId: number | null;
  setSearchQuery: (query: string) => void;
  setProjId: (id: number) => void;
  setLoading: (loading: boolean) => void;
  setRenderSearchResults: (isOpen: boolean) => void;
  setShowProjectDetails: (isOpen: boolean) => void;
  setShowSavedInvestorPage: (showInvestorContent: boolean) => void;
  setSearchResults: (searchResults: SearchResults) => void;
  setProjectById: (projectById: ProjectById) => void;
}

export const useAppStore = create<AppStoreState>()(
  devtools((set) => ({
    renderSearchResults: false,
    showProjectDetails: false,
    showSavedInvestorPage: false,
    searchResults: null,
    projectById: null,
    loading: false,
    projectId: null,
    searchQuery: '',
    setSearchQuery: (searchQuery) => set(() => ({ searchQuery: searchQuery })),
    setProjId: (projectId) => set(() => ({ projectId: projectId })),
    setLoading: (loading) => set(() => ({ loading: loading })),
    setProjectById: (projectById) => set(() => ({ projectById: projectById })),
    setSearchResults: (searchResults) => set(() => ({ searchResults: searchResults })),
    setRenderSearchResults: (renderSearchResults) => set(() => ({ renderSearchResults: renderSearchResults })),
    setShowProjectDetails: (showProjectDetails: boolean) => set(() => ({ showProjectDetails: showProjectDetails })),
    setShowSavedInvestorPage: (showSavedInvestorPage: boolean) =>
      set(() => ({ showSavedInvestorPage: showSavedInvestorPage })),
  })),
);
